import { render, staticRenderFns } from "./MemberPaperAttachNew.vue?vue&type=template&id=17d7cd51&scoped=true&"
import script from "./MemberPaperAttachNew.vue?vue&type=script&lang=js&"
export * from "./MemberPaperAttachNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberPaperAttachNew.vue?vue&type=style&index=0&id=17d7cd51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7cd51",
  null
  
)

export default component.exports